import { snapShots } from "../../constants/apiUrl";
import { urlBinder } from "../../helper/url-binder";
import { IApiResponse } from "../../models/IAPIResponse";
import { ISnapShotData, ISnapShots } from "../../models/master/snapShot";
import APIService from "../../helper/api-service";

export default new (class SnapShotService {
  public getSnapShot = async (
    id: number
  ): Promise<IApiResponse<ISnapShotData>> => {
    try {
      let endPoint = urlBinder(snapShots.GET_SNAPSHOT, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ISnapShotData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ISnapShotData>;
      } else {
        throw error;
      }
    }
  };

  public getSnapShots = async (
    configUserRole?: number
  ): Promise<IApiResponse<Array<ISnapShots>>> => {
    try {
      let endPoint = urlBinder(snapShots.GET_ALL_SNAPSHOTS, [configUserRole]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<ISnapShots>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<ISnapShots>>;
      } else {
        throw error;
      }
    }
  };

  public updateSnapShot = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(snapShots.UPDATE_SNAPSHOT, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateVisibility = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = snapShots.UPDATE_SNAPSHOT_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };
})();
